import React, { useState } from 'react';
import './header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import ageCoLogo from '../../assets/img/age_co_logo.jpg';

function Header(props) {

  const [isActive, setIsActive] = useState(false)
    
  const handleClick = () => {
      setIsActive(!isActive)
  }

  return (
    <>
        <header className="header">
          <img className="header__logo" src={ageCoLogo} alt="Age Co Funeral Plans logo" height="134" width="auto" />
          
          <div className={isActive ? 'header__mob-menu active' : 'header__mob-menu'} onClick={handleClick}>
            {isActive ? <FontAwesomeIcon icon={faTimes} /> : <FontAwesomeIcon icon={faBars} />}
                Menu
                <div className="header__menu-dropdown">
                    {props.nav.map((navItem, index) => (
                        <a key={index} className="header__nav-item" href={navItem.Url}>{navItem.Name}</a>
                    ))}
                </div>
            </div>
          <nav className="header__nav">
          {props.nav.map((navItem, index) => (
            <a key={index} className="header__nav-item" href={navItem.Url}>{navItem.Name}</a>
          ))}
          </nav>
        </header>
        <div className="header__blocks">
            <div key={props.blocks[0].id} className="bg-skyblue">
                <p className="phone">{props.blocks[0].phone}</p>
                <p className="call-hours">{props.blocks[0].openingHours}</p>
            </div>
            <div key={props.blocks[1].id} className="bg-salmon">
                <p className="centre-large">{props.blocks[1].content}</p>
            </div>
            <div key={props.blocks[2].id} className="bg-metal-grey">
                <p className="centre-large">{props.blocks[2].content}</p>
            </div>
        </div>
        
    </>
  );
}

export default Header;
